import React, { useContext } from "react";
import { IOneGuest } from "../../component";
import { style } from "../../utils/image";
import "./Guests.scss";
import { ThemeContext } from "../../store/ThemeProvider";
import classNames from "classnames";
import { getScrollCls } from "../../utils/util";

interface IGuests {
  edittype: string;
  content: IOneGuest[];
  onItemClick?: (data: IOneGuest) => void;
}
const Guests = function (props: IGuests) {
  const { edittype, content, onItemClick } = props;
  const themeContext = useContext(ThemeContext);

  return (
    <div className={classNames("guests " + edittype, getScrollCls())}>
      {(content || [])
        .map((one: IOneGuest, index: number) => {
          if (edittype == "template1") {
            return (
              <div
                className="item"
                key={index}
                style={{ background: themeContext.componentColor }}
                onClick={() => {
                  onItemClick?.(one);
                }}
              >
                {/*由于历史久远，这个地方在oms后台其实显示的是方形，但是这里不知道为什么要用长方形，姑且保留*/}
                <img className={"photo"} src={style(one.photo, "wx_164_200")} />
                <div className="name" style={{ color: themeContext.h1Color }}>
                  {one.name}
                </div>
                <div className="desc" style={{ color: themeContext.h2Color }}>
                  {one.desc}
                </div>
              </div>
            );
          }
          if (edittype == "template2") {
            return (
              <div
                className="item"
                key={index}
                style={{ background: themeContext.componentColor }}
              >
                {/*跟珊婷确认，这里用长图*/}
                <img className={"photo"} src={style(one.photo, "wx_164_200")} />
                <div className="info">
                  <div className="name" style={{ color: themeContext.h1Color }}>
                    {one.name}
                  </div>
                  <div className="desc" style={{ color: themeContext.h2Color }}>
                    {one.desc}
                  </div>
                </div>
              </div>
            );
          }
          return null;
        })
        .filter(Boolean)}
    </div>
  );
};

export default Guests;
